export const SPECIALS_GET = "SPECIALS_GET";
export const SPECIALS_FILTER_TYPES_GET = "SPECIALS_FILTER_TYPES_GET";
export const SPECIALS_FILTER_DATES_GET = "SPECIALS_FILTER_DATES_GET";
export const SPECIALS_FILTER_OPTIONS_GET = "SPECIALS_FILTER_OPTIONS_GET";
export const SPECIALS_CHANGE_VIEW = "SPECIALS_CHANGE_VIEW";
export const SPECIALS_RESET = "SPECIALS_RESET";



// WEBPACK FOOTER //
// ./src/modules/specials/actionTypes.js